STARTER_LICENSE_COURSE_IDS = [
  "560f1a9f22961295f9427742" # Introduction to Computer Science
  "5632661322961295f9428638" # Computer Science 2
  "5789587aad86a6efb573701e" # Game Development 1
  "5789587aad86a6efb573701f" # Web Development 1
]

FREE_COURSE_IDS = [
  "560f1a9f22961295f9427742" # Introduction to Computer Science
]

MAX_STARTER_LICENSES = 75

STARTER_LICENCE_LENGTH_MONTHS = 6

module.exports = {
  STARTER_LICENSE_COURSE_IDS
  FREE_COURSE_IDS
  MAX_STARTER_LICENSES
  STARTER_LICENCE_LENGTH_MONTHS
}



// WEBPACK FOOTER //
// ./app/core/constants.coffee